import { DirectionalHint } from '@fluentui/react';
import { IBubbleCategoryMap } from '../models';

export const categoryMap: IBubbleCategoryMap = {
  logo: {
    targetId: 'uatLogo',
    bubblePosition: DirectionalHint.bottomRightEdge,
  },
  leftNavigation: {
    targetId: 'leftNavigation',
    bubblePosition: DirectionalHint.rightTopEdge,
  },
  overview: {
    targetId: 'overviewLabel',
    bubblePosition: DirectionalHint.rightCenter,
  },
  createAction: {
    targetId: 'createAction',
    bubblePosition: DirectionalHint.rightCenter,
  },
  dashboardIcon: {
    targetId: 'dashboard-icon',
    bubblePosition: DirectionalHint.rightCenter,
  },
  dashboardTitle: {
    targetId: 'dashboardTitle',
    bubblePosition: DirectionalHint.topLeftEdge,
  },
  dashboardSummaryCard: {
    targetId: 'dashboardSummaryCard',
    bubblePosition: DirectionalHint.rightCenter,
  },
  dashboardSummaryDropdown: {
    targetId: 'dashboardSummaryDropdown',
    bubblePosition: DirectionalHint.rightCenter,
  },
  dashboardDataGrid: {
    targetId: 'dashboardDataGrid',
    bubblePosition: DirectionalHint.bottomCenter,
  },
  dashboardFilter: {
    targetId: 'dashboardFilter',
    bubblePosition: DirectionalHint.bottomCenter,
  },
  dashboardPagination: {
    targetId: 'dashboardPagination',
    bubblePosition: DirectionalHint.topCenter,
  },
  riskMenu: {
    targetId: 'RiskMenu',
    bubblePosition: DirectionalHint.rightCenter,
  },
  issueMenu: {
    targetId: 'IssueMenu',
    bubblePosition: DirectionalHint.rightCenter,
  },
  dependencyMenu: {
    targetId: 'DependencyMenu',
    bubblePosition: DirectionalHint.rightCenter,
  },
  manageactionwrapper: {
    targetId: 'manageactionwrapper',
    bubblePosition: DirectionalHint.leftCenter,
  },
  tablist: {
    targetId: 'tablist',
    bubblePosition: DirectionalHint.rightCenter,
  },
  state: {
    targetId: 'state',
    bubblePosition: DirectionalHint.rightCenter,
  },
  additionalOptions: {
    targetId: 'additionalOptions',
    bubblePosition: DirectionalHint.rightCenter,
  },
  copilotCard: {
    targetId: 'copilotCard',
    bubblePosition: DirectionalHint.bottomCenter,
  },
  copilotCardSimilarActions: {
    targetId: 'copilotCardSimilarActions',
    bubblePosition: DirectionalHint.bottomCenter,
  },
  fieldRequestHelp: {
    targetId: 'fieldRequestTeachingBubble',
    bubblePosition: DirectionalHint.topRightEdge,
  },

  // copilotCardInsights: {
  //   targetId: 'copilotCardInsights',
  //   bubblePosition: DirectionalHint.bottomCenter,
  // },
};
